// src/lib/utils/devLogger.ts

/**
 * 개발 또는 테스트 환경에서만 콘솔 로그를 출력하는 유틸 함수
 * - development 환경
 * - http 프로토콜 (테스트 서버 등)
 * - .env.development 기준 개발 서버 주소 매칭
 */

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const isMatchingDevAddress = (urlString?: string): boolean => {
  if (!urlString || typeof window === 'undefined') {
    return false;
  }

  try {
    const parsed = new URL(urlString);
    return (
      parsed.origin === window.location.origin ||
      parsed.hostname === window.location.hostname
    );
  } catch {
    return false;
  }
};

export const isDevEnvironment = (): boolean => {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV === 'development';
  }

  const { protocol, hostname } = window.location;

  // 로컬 접속 또는 http 접속은 개발로 간주
  if (LOCAL_HOSTS.has(hostname) || protocol === 'http:') {
    return true;
  }

  // https는 기본 운영으로 보되, 개발 서버 주소와 일치하면 개발로 간주
  return (
    isMatchingDevAddress(process.env.REACT_APP_API_DEV_URL) ||
    isMatchingDevAddress(process.env.REACT_APP_API_HOST) ||
    isMatchingDevAddress(process.env.REACT_APP_SOCKET_URL)
  );
};

const isLocalDev = isDevEnvironment();

export const devLog = (...args: any[]) => {
  if (isLocalDev) {
    console.log(...args);
  }
};

export const devWarn = (...args: any[]) => {
  if (isLocalDev) {
    console.warn(...args);
  }
};

export const devError = (...args: any[]) => {
  if (isLocalDev) {
    console.error(...args);
  }
};

/**
 * 로그아웃 과정 전용 로그 함수
 */
export const logoutLog = (message: string, data?: any) => {
  if (isLocalDev) {
    const timestamp = new Date().toISOString();
    console.log(`🔓 [LOGOUT ${timestamp}] ${message}`, data || '');
  }
};

/**
 * Flutter 브릿지 통신 전용 로그 함수
 */
export const flutterBridgeLog = (message: string, data?: any) => {
  if (isLocalDev) {
    const timestamp = new Date().toISOString();
    console.log(`🌉 [FLUTTER-BRIDGE ${timestamp}] ${message}`, data || '');
  }
};
